import {GET, POST} from "../util";

const inspectionUrl = "api/buyer/put-options/inspection";
const operationUrl = "api/buyer/put-options/operation";

const url = {
	inspection: {
		buyAccounts: `${inspectionUrl}/buy-accounts`,
		accounts: `${inspectionUrl}/accounts`,
		listExchange: `${inspectionUrl}/list-exchange/:accountId`,
		listPayments: `${inspectionUrl}/list-payments/:accountId`,
		listContracts: `${inspectionUrl}/list-contracts/:accountId`,
		listReceivables: `${inspectionUrl}/list-receivables/:offerId`,
		paymentPlan: `${inspectionUrl}/:offerId/payment-plan`,
		assignmentConfirmation: `${inspectionUrl}/:offerId/assignment-confirmation`,
	},
	operation: {
		makeOffer: `${operationUrl}/offer/make`,
		editOffer: `${operationUrl}/offer/:offerId/edit`,
		cancel: `${operationUrl}/offer/:offerId/cancel`,
		confirmAssignment: `${operationUrl}/auction/:auctionId/confirm-assignment/:confirmedPrice`,
	}
};

const revolvingPutOptionsBuyerApi = {
	inspection: {
		getBuyAccounts: () => {
			return GET(url.inspection.buyAccounts);
		},
		getAccounts: (params = {}) => {
			return GET(url.inspection.accounts, params);
		},
		listExchange: (accountId, params = {}) => {
			return POST(url.inspection.listExchange.replace(":accountId", accountId), params);
		},
		listPayments: (accountId, params = {}) => {
			return POST(url.inspection.listPayments.replace(":accountId", accountId), params);
		},
		listContracts: (accountId, params = {}) => {
			return POST(url.inspection.listContracts.replace(":accountId", accountId), params);
		},
		listReceivables: (offerId, params = {}) => {
			return POST(url.inspection.listReceivables.replace(":offerId", offerId), params);
		},
		getPaymentPlan: (offerId) => {
			return GET(url.inspection.paymentPlan.replace(":offerId", offerId));
		},
		getAssignmentConfirmations: (offerId) => {
			return GET(url.inspection.assignmentConfirmation.replace(":offerId", offerId));
		},
	},
	operation: {
		makeOffer: (params) => {
			return POST(url.operation.makeOffer, params);
		},
		editOffer: (offerId, params) => {
			return POST(url.operation.editOffer.replace(":offerId", offerId), params);
		},
		cancelPutOption: (offerId) => {
			return POST(url.operation.cancel.replace(":offerId", offerId));
		},
		confirmAssignment: (auctionId, confirmedPrice) => {
			return POST(url.operation.confirmAssignment.replace(":auctionId", auctionId).replace(":confirmedPrice", confirmedPrice));
		},
	}
};

export {
	revolvingPutOptionsBuyerApi
};
